import { render, staticRenderFns } from "./MultipleUsersSettings.vue?vue&type=template&id=53b9df68&scoped=true"
import script from "./MultipleUsersSettings.vue?vue&type=script&lang=js"
export * from "./MultipleUsersSettings.vue?vue&type=script&lang=js"
import style0 from "./MultipleUsersSettings.vue?vue&type=style&index=0&id=53b9df68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b9df68",
  null
  
)

export default component.exports